// @ts-nocheck
export const GET_DELETED_USERS_REQUEST = "GET_DELETED_USERS_REQUEST";
export const GET_DELETED_USERS_SUCCESS = "GET_DELETED_USERS_SUCCESS";
export const GET_DELETED_USERS_FAILURE = "GET_DELETED_USERS_FAILURE";

export const RECOVER_DELETED_USER_REQUEST = "RECOVER_DELETED_USER_REQUEST";
export const RECOVER_DELETED_USER_SUCCESS = "RECOVER_DELETED_USER_SUCCESS";
export const RECOVER_DELETED_USER_FAILURE = "RECOVER_DELETED_USER_FAILURE";

export const CLEAR_MESSAGE = "CLEAR_MESSAGE";

export const PERMANENT_DELETE_USER_REQUEST = "PERMANENT_DELETE_USER_REQUEST";
export const PERMANENT_DELETE_USER_SUCCESS = "PERMANENT_DELETE_USER_SUCCESS";
export const PERMANENT_DELETE_USER_FAILURE = "PERMANENT_DELETE_USER_FAILURE";

export const PERMANENT_DELETE_ELGIBLE_REQUEST = "PERMANENT_DELETE_ELGIBLE_REQUEST";
export const PERMANENT_DELETE_ELGIBLE_SUCCESS = "PERMANENT_DELETE_ELGIBLE_SUCCESS";
export const PERMANENT_DELETE_ELGIBLE_FAILURE = "PERMANENT_DELETE_ELGIBLE_FAILURE";